import { useEffect, useState } from 'react'
import '../../assets/styles/customFilter.css'

const CustomNumberFilter = ({ colDef, setApiParams }) => {
  const { id } = colDef
  const [selectedFilter, setSelectedFilter] = useState("")
  const [minVal, setMinVal] = useState(null)
  const [maxVal, setMaxVal] = useState(null)

  useEffect(() => {
    if (selectedFilter === "") {
      setMinVal(null)
      setMaxVal(null)
    }
  }, [selectedFilter])

  useEffect(() => {
    setApiParams(oldParams => {
      try {
        // handling "between" filter
        if ((!['', 'between'].includes(selectedFilter) && minVal) ||
          (selectedFilter === 'between' && minVal && maxVal && parseFloat(minVal) < parseFloat(maxVal))) {
          const newFilterColDef = {
            colId: id,
            filterType: selectedFilter,
            dataType: 'number',
            minVal,
            maxVal: selectedFilter === 'between' ? maxVal : null
          }
          return {
            ...oldParams,
            filterCols: oldParams.filterCols.find(filter => filter.colId === id) ?
              [...oldParams.filterCols.filter(filter => filter.colId !== id), newFilterColDef] :
              [...oldParams.filterCols, newFilterColDef]
          }
        } else {
          // handling other filters except "between"
          return {
            ...oldParams,
            filterCols: [...oldParams.filterCols.filter(filter => filter.colId !== id)]
          }
        }
      } catch (error) {
        console.log(error)
        return { ...oldParams }
      }
    })
  }, [selectedFilter, minVal, maxVal])

  return (
    <div className="customFilter">
      <div className="customSelect">
        <select
          value={selectedFilter}
          onChange={e => setSelectedFilter(e.target.value)}
        >
          <option value="">Select Filter</option>
          <option value="lessThan">Less Than</option>
          <option value="lessThanEqualTo">Less Than Equal To</option>
          <option value="greaterThan">Greater Than</option>
          <option value="greaterThanEqualTo">Greater Than Equal To</option>
          <option value="between">Between</option>
          <option value="equalTo">Equal To</option>
          <option value="notEqualTo">Not Equal To</option>
        </select>
      </div>

      {selectedFilter !== '' &&
        <div className="inputsDiv">
          <input
            type="number"
            step="any"
            value={minVal}
            disabled={selectedFilter === ''}
            placeholder={selectedFilter === 'between' ? 'Enter Lower Val...' : 'Enter Value...'}
            onChange={e => setMinVal(e.target.value)}
          />

          {selectedFilter === 'between' &&
            <input
              type="number"
              step="any"
              value={maxVal}
              disabled={selectedFilter === ''}
              placeholder='Enter Higher Val...'
              onChange={e => setMaxVal(e.target.value)}
            />
          }
        </div>
      }
    </div>
  )
}

export default CustomNumberFilter
